import React, { Component } from 'react'
import TextInputUI from './TextInputUI.js'

class TextInputSF2 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value
    }
  }

  render() {
    return (
      <TextInputUI
        value={this.state.value}
        onChange={this.onChange}
        maxLength={this.props.maxLength}
        messageList={this.props.messageList}
        placeholderKey={this.props.placeholderKey}
      />
    )
  }

  onChange = (event) => {
    let value = event.target.value
    switch(this.props.type) {
      case 'Integer':
        if (value && !value.match(/^-{0,1}\d*$/))
          return
        break;
      default:
    }
    this.setState({value: value})
    this.props.onSubmit(value)
  }
}

export default TextInputSF2
